import { db } from '@/firebase/init';
import { collectionGroup, orderBy, query, where } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';
import { InvitationFromStore } from '@/types/types';

function useUserWorkspacesInvitations(
  userId: string,
): InvitationFromStore<'workspace'>[] {
  const invitationsQuery = useMemo(
    () =>
      query(
        collectionGroup(db, 'invitations'),
        where('invitedUserId', '==', userId),
        orderBy('createdAt', 'desc'),
      ),
    [userId],
  );

  const invitations = useFirestoreCollection<InvitationFromStore<'workspace'>>(
    ['workspacesInvitations', userId],
    invitationsQuery,
  );

  return invitations;
}

export { useUserWorkspacesInvitations };
